import { QuickQuoteResponseQuote } from 'lib/api/getQuickQuote';
import { Maybe } from 'types/UtilityTypes';
import {
  Quoting,
  QuotingPortals,
  integrationNameMap,
} from 'types/enums/Integrations';

import { DistanceSource } from '../QuickQuoteForm';

/** Matches drumkit `models.DistanceSourcePCMiler`. */
export const PCMilerDistanceSource = 'pcmiler';

export function resolveQuoteMileageSource(
  quote: Pick<QuickQuoteResponseQuote, 'source' | 'distanceSource'>
): DistanceSource {
  if (quote.distanceSource === PCMilerDistanceSource) {
    return PCMilerDistanceSource as DistanceSource;
  }
  return quote.source as DistanceSource;
}

/** Quote `source` to match when `distanceSource` is PC*Miler mileage under a DAT quote. */
export function quoteSourceForLegMetadata(
  distanceSource: Maybe<DistanceSource>
): Maybe<DistanceSource> {
  if (distanceSource === PCMilerDistanceSource) {
    return Quoting.DAT as DistanceSource;
  }
  return distanceSource;
}

export function getMileageSourceLabel(
  source: Maybe<DistanceSource | Quoting | QuotingPortals | string>
): string {
  if (!source) {
    return '';
  }
  if (source === PCMilerDistanceSource) {
    return 'PC*Miler';
  }
  return (
    integrationNameMap[source as keyof typeof integrationNameMap] ??
    String(source)
  );
}
